import { h, render } from 'preact';
import App from './containers/App'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById ( 'js-cases-app' )
 


if ( container ) {
  const hide = container.dataset.hide
  const title = container.dataset.title
  const subtitle = container.dataset.subtitle
  const content = container.dataset.content
  const buttonUrl = container.dataset.url
  const buttonContent = container.dataset.cta

  render( 
    <App 
      hide={hide} 
      ctaTitle={title} 
      ctaSubtitle={subtitle} 
      ctaContent={content} 
      ctaButtonUrl={buttonUrl} 
      ctaButtonContent={buttonContent} 
    />, container )
}


// WEBPACK FOOTER //
// ./src/js/app/index.js